<!--  -->
<template>
  <div class="box">
    <div class="title">
      <img src="~@/assets/images/active/active20230406/5.png" alt="" />
    </div>

    <div
      v-if="list.length"
      :style="{ paddingBottom: swiperIndex === 3 ? '0.5rem' : 0 }"
      class="mt"
    >
      <Swipe
        ref="Swiper"
        :loop="false"
        :show-indicators="false"
        :height="swiperHeight"
        @change="onChange"
      >
        <SwipeItem v-for="(item, index) in list" :key="index">
          <div ref="swiperItem" class="border">
            <img
              class="top"
              src="~@/assets/images/active/active20230406/2.png"
              alt=""
            />
            <div class="center">
              <div class="question">
                <p class="question-title">
                  {{ item.title }}
                </p>
                <div v-if="item.img" class="question-img">
                  <img :src="item.img" alt="" @click="onPreview(item.img)" />
                </div>
                <div class="list">
                  <div
                    v-for="(qItem, qIndex) in item.questions"
                    :key="qIndex"
                    :class="{ active: item.check.includes(qItem.value) }"
                    class="list-item"
                    @click="onCheck(item, qItem, index)"
                  >
                    {{ qItem.label }}
                  </div>
                </div>
              </div>
            </div>
            <img
              class="bottom"
              src="~@/assets/images/active/active20230406/3.png"
              alt=""
            />
          </div>
        </SwipeItem>
      </Swipe>
    </div>

    <div v-if="showBtn" class="btn-box">
      <div class="btn" @click="toNextPage">答题完毕</div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, ImagePreview, Dialog } from "vant";
import { mapState, mapActions } from "vuex";
// import { h5 } from "@/utils/env";
// import { initShare } from "@/utils";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Swipe,
    SwipeItem,
  },
  data() {
    //这里存放数据
    return {
      list: [],
      swiperIndex: 0,
      swiperHeight: "auto",
      initShareObg: {},
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState(["rjQuestions"]),
    showBtn() {
      return this.swiperIndex > 0 && this.swiperIndex + 1 === this.list.length;
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.list = JSON.parse(JSON.stringify(this.rjQuestions));
    this.$nextTick(() => {
      setTimeout(() => {
        this.setSwiperHeight();
      }, 300);
    });
    /* this.initShareObg = new initShare({
      shareUrl: `${h5}app/v2/active/20230406-ruijie.html`,
      sharePath: "commonh5",
      imgUrl: require("@/assets/images/active/active20230406/share.png"),
      miniAppImgUrl: "https://static.shenzhoubb.com/images/miniapp/share.png",
      title: "擂台赛敢不敢来打！",
      desc: "锐捷数通工程师招募火热开启中...",
    }); */
    sessionStorage.setItem("questionNum", 0);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  //方法集合
  methods: {
    ...mapActions(["setQuestionNum"]),
    onCheck(item, qItem, index) {
      const check = item.check || [];
      if (item.type === "radio") {
        item.check = [qItem.value];
      } else {
        if (check.find((item) => item === qItem.value)) {
          item.check = check.filter((item) => item !== qItem.value);
        } else {
          check.push(qItem.value);
          item.check = check;
        }
      }
      if (index !== this.list.length) {
        this.$refs["Swiper"].next();
      }
    },
    onPreview(img) {
      ImagePreview([img]);
    },
    onChange(index) {
      this.swiperIndex = index;
      this.setSwiperHeight();
    },
    setSwiperHeight() {
      this.$nextTick(() => {
        const height = this.$refs["swiperItem"][this.swiperIndex]?.offsetHeight;
        this.swiperHeight = height > 0 ? height + 2 : "auto";
        this.$refs["Swiper"].resize();
      });
    },
    toNextPage() {
      const check = this.list.filter((item) => item.check && item.check.length);
      if (check.length < this.list.length) {
        Dialog.confirm({
          title: "提示",
          message: "您还有未答题题目，是否继续答题？",
          beforeClose: (action, done) => {
            if (action === "confirm") {
              done();
            } else {
              this.setData(done);
            }
          },
        });
      } else {
        this.setData();
      }
    },
    setData(done) {
      let num = 0;
      for (const val of this.list) {
        if (val.type === "radio" && val.check.includes(val.answer)) {
          num += 1;
        }

        if (val.type === "check") {
          const a = val.questions
            .filter((item) => val.check.includes(item.value))
            ?.map((item) => item.value)
            ?.join(",");

          if (a === val.answer) {
            num += 1;
          }
        }
      }
      sessionStorage.setItem("questionNum", num);
      this.setQuestionNum(num);
      this.$router.push({
        path: "/20230406-other.html",
      });
      done && done();
    },
  },
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.box {
  position: relative;
  box-sizing: border-box;
  width: 7.5rem;
  min-height: 100vh;
  margin: 0 auto;
  background: #f1ece3;
  background-image: url(~@/assets/images/active/active20230406/6.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.title {
  box-sizing: border-box;
  width: 100%;
  padding: 1.97rem 0.8rem 1.03rem 0.57rem;

  img {
    display: block;
    width: 100%;
  }
}

.border {
  width: 6.5rem;
  margin: 0 auto;

  img {
    display: block;
    width: 100%;
  }

  .top {
    min-height: 0.68rem;
  }
  .bottom {
    min-height: 0.68rem;
  }

  .center {
    box-sizing: border-box;
    width: 100%;
    min-height: 6.23rem;
    background: #ebdcc2;
    background-image: url(~@/assets/images/active/active20230406/7.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}

.question {
  width: 5.83rem;
  margin: 0 auto;
  overflow: hidden;

  &-title {
    margin-top: 0.31rem;
    font-size: 0.3rem;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: #000000;
    line-height: 0.3rem;
  }

  &-img {
    width: 5.83rem;
    margin-top: 0.2rem;

    img {
      display: block;
      width: 100%;
    }
  }

  .list {
    margin-top: 1.04rem;

    &-item {
      box-sizing: border-box;
      margin-bottom: 0.35rem;
      height: 0.88rem;
      text-align: center;
      line-height: 0.88rem;
      font-size: 0.32rem;
      font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
      font-weight: 400;
      color: #000000;
      background: #ebdcc2;
      border-radius: 0.44rem;
      border: 1px solid #000000;

      &.active {
        color: #ca0c08;
        border: 0.03rem solid #ca0c08;
      }
    }
  }
}

.mt {
  box-sizing: border-box;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-box {
  padding: 0.3rem 0 0.5rem;
}

.btn {
  width: 2.39rem;
  height: 0.8rem;
  margin: 0 auto;
  font-size: 0.36rem;
  text-align: center;
  line-height: 0.8rem;
  background: #000000;
  color: #fff;
  border-radius: 0.4rem;
}
</style>